<template>
    <v-dialog :value="value" max-width="500px" @input="toggleModal">
        <v-card color="kbLight">
            <v-toolbar color="kbPurple" dark flat>
                <v-toolbar-title>
                    {{ $t('general.sendCampaign') }}
                </v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn icon @click="toggleModal">
                    <v-icon>clear</v-icon>
                </v-btn>
            </v-toolbar>

            <v-card-text>
                <v-form v-model="valid" ref="formSendCampaign" lazy-validation>
                    <v-row>
                        <v-col cols="12">
                            <DateTimePicker v-model="scheduleDate"
                                            :min="minDate"
                                            :label="$t('general.shippingDateAndTime')"
                                            :rules="[rules.required]">
                            </DateTimePicker>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="kbPurple"
                       dark
                       @click="sendCampaign()"
                       :loading="loading">
                    {{ $t('general.scheduleCampaign') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import DateTimePicker from '@/components/ui/DateTimePicker.vue'
import moment from 'moment'
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
export default {
  components: { DateTimePicker },
  data: () => ({
    dateTime: '',
    loading: false,
    minDate: moment().format('YYYY-MM-DD'),
    rules,
    scheduleDate: undefined,
    valid: true
  }),
  methods: {
    sendCampaign () {
      if (!this.$refs.formSendCampaign.validate()) return

      const data = {
        campaignId: this.$route.params.campaignid,
        schedule: true,
        scheduleDate: this.scheduleDate
      }

      this.loading = true
      this.$store.dispatch('sendCampaign', data).then(() => {
        this.loading = false
        this.toggleModal()
      }).catch((error) => {
        this.loading = false
        notifications.error(error.message)
      })
    },
    toggleModal () {
      this.$refs.formSendCampaign.reset()
      this.$emit('input', false)
    }
  },
  props: ['value']
}
</script>
